@for (section of sections; track section; let i = $index) {
  <div class="container-fluid accordion-container">
    <div [classList]="[['PROPOSALS', 'INVITE_PAGES'].includes(section.section) ? 'container-fluid px-0' : 'container']">
      <mat-accordion class="accordion" multi>
        <mat-expansion-panel [expanded]="section.expanded">
          <mat-expansion-panel-header class="container px-0">
            <mat-panel-title>
              <span class="index">{{ i + 1 }}</span>
              {{ section.title | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngTemplateOutlet="section.template"></ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
}

<!-- Buttons -->
<div class="buttons-container container py-4">
  <button class="button-primary float-left" mat-button [disabled]="loading || true">
    <i class="icon-Backward-arrow-small"></i>
    {{ "generic.buttons.save-and-back" | translate }}
  </button>
  <button class="button-primary float-right" mat-button [disabled]="loading || true">
    <i class="icon-Forward-arrow-small"></i>
    {{ "generic.buttons.save-and-close" | translate }}
  </button>
</div>

<ng-template #dialogTemplate>
  <div class="container">
    <div class="row">
      <div class="col-12" style="font-size: 25px">
        {{
        "components.decision-table.show-decision-table.bot-proposal"
        | translate
        }}
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        {{
        "components.decision-table.show-decision-table.ask-bot-create-proposal"
        | translate
        }}
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-6">
        <button color="primary" mat-raised-button (click)="confirmGenerateProposal()">
          {{ "generic.answers.yes" | translate }}
        </button>
      </div>
      <div class="col-6">
        <button mat-raised-button (click)="dialog.closeAll()">
          {{
          "components.decision-table.show-decision-table.ask-bot-info"
          | translate
          }}
        </button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #timelineTemplate>
  <div class="row">
    <div class="stepper-container col-12">
      <p class="headline float-left">
        {{
        "components.decision-table.show-decision-table.evaluation-sessions"
        | translate
        }}
      </p>
      <p class="headline float-right">
        {{ "generic.report" | translate }}
      </p>
      <div class="timeline">
        @for (session of evaluation_sessions_row_1; track session; let i = $index) {
          <div class="step-container" [ngClass]="session.collecting == true ? 'current' : ''"
            >
            <ng-container>
              <div class="step">{{ i + 1 }}</div>
              @if (session.evaluation_start) {
                <div class="step-label">
                  {{ session.evaluation_start | formatdate | date : "short" }}
                  <br />
                  @if (!session.collecting) {
                    <span>{{
                      session.evaluation_end | formatdate | date : "short"
                    }}</span>
                  }
                </div>
              }
              @if (!session.evaluation_start) {
                <div class="step-label">
                  {{
                  "components.decision-table.show-decision-table.not-started-yet"
                  | translate
                  }}
                </div>
              }
            </ng-container>
          </div>
        }
        @if (
          evaluation_sessions_row_1.length < evaluation_sessions_by_row
          ) {
          <div class="step-container icon-container">
            <div class="step">
              <i class="icon-Flag"></i>
            </div>
          </div>
        }
        <!-- <div class="step-container current">
        <div class="step">2</div>
        <div class="step-label">17 Luglio 2020</div>
      </div> -->
    </div>
  </div>
  @if (
    evaluation_sessions_row_1.length >= evaluation_sessions_by_row
    ) {
    <div class="stepper-container col-12">
      <div class="timeline until-end">
        @for (session of evaluation_sessions_row_2; track session; let i = $index) {
          <div class="step-container" [ngClass]="session.collecting == true ? 'current' : ''"
            >
            <ng-container>
              <div class="step">
                {{ evaluation_sessions_by_row + i + 1 }}
              </div>
              <div class="step-label">{{ session.decision_start }}</div>
            </ng-container>
          </div>
        }
        <div class="step-container icon-container">
          <div class="step">
            <i class="icon-Flag"></i>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<div class="row col-12 d-flex mb-3">

  @if (isConsulted != null) {
    <button class="mr-3 mb-1 pink"
      [routerLink]="['/responses/'+isConsulted?.evaluation_session_id+'/welcome']" routerLinkActive="router-link-active"
      matButton="filled" color="primary">{{ 'components.responses.ask-for-response' | translate }}
    </button>
  }

  <!-- Aggiungo un flex per mandare i pulsanti dall'altro lato-->
  <div class="mx-auto"></div>

  @if (decision_table.closing_date) {
    <div class="detailed-button mr-3 mb-1">
      <button matButton="filled" color="primary" (click)="onClickReopenDecisionTable()">
        {{
        "components.decision-table.show-decision-table.reopen-project"
        | translate
        }}
      </button>
      <i class="icon-lock-open"></i>
    </div>
  }

  <!-- Chiude la sessione se c'è ne una attiva -->
  @if (!decision_table.closing_date) {
    @if (evaluationSessionActive && !isInformed) {
      <div class="detailed-button mr-3 mb-1">
        <button matButton="filled" color="primary" (click)="onClickCloseEvaluationSession()"
          [disabled]="!evaluationSessionActive || loading">{{
          'components.decision-table.show-decision-table.close-session' | translate }}
        </button>
        <i class="icon-lock-open"></i>
        <label>{{ modelStartNewEvaluation.closing_date | formatdate | date:'mediumDate' }}</label>
      </div>
    }
    <!-- Chiude il tavolo decisionale se non ci sono sessioni attive -->
    @if (sessionsEvalutated && !evaluationSessionActive) {
      <div class="detailed-button mr-3 mb-1">
        <button matButton="filled" color="primary" (click)="onClickCloseDecisionTable()"
          [disabled]="!sessionsEvalutated || loading">
          {{
          "components.decision-table.show-decision-table.closetable"
          | translate
          }}
        </button>
        <i class="icon-lock-open"></i>
      </div>
    }
  }

  <ng-container>
    <div class="mr-3 mb-1">
      <button matButton="filled" color="primary" [routerLink]="['/decision/' + id + '/task-management']"
        routerLinkActive="router-link-active" [disabled]="locked">
        {{ "generic.task-management" | translate }}
      </button>
    </div>
  </ng-container>

  <button class="mb-1" matButton="filled" color="primary" [disabled]="numOfProposalEvaluated == 0"
    [routerLink]="['/decision/' + id + '/dashboard']" routerLinkActive="router-link-active">
    {{ "generic.dashboard" | translate }}
  </button>

  @if (decision_table.closing_date != null) {
    <div class="mr-3 mb-1">
      <button mat-button color="primary" (click)="onClickDownloadExcelData()">
        <mat-icon aria-hidden="false">description</mat-icon>
        {{ "generic.export-data" | translate }}
      </button>
    </div>
  }
</div>
</ng-template>

<ng-template #detailsTemplate>
  <div class="container my-5">
    <app-decision-table-details [decision_table]="decision_table" [show_indexes]="false" [isResponse]="false" />
  </div>
</ng-template>

<ng-template #contestsTemplate>
  <div class="row container pt-4 pb-2 mx-auto">
    <div class="col-12 p-0 m-0">
      @if (contestDataSource && contestDataSource?.data.length == 0) {
        <div class="row">
          <div class="col-12 text-center mb-4 mt-2">
            <p>
            {{ 'components.decision-table.show-decision-table.no-contests' | translate }}</p>
          </div>
          <div class="col-12 d-flex justify-content-center my-5">
            <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" (click)="addNewContest()">
              <mat-icon class="mr-2">play_circle_outlined</mat-icon>
              {{ 'generic.create-new-contest' | translate }}
            </button>
          </div>
        </div>
      }
      @if (contestDataSource && contestDataSource.data.length > 0 && !contestIsCollecting()) {
        <div class="row justify-content-center mb-4">
          <div class="col-12 d-flex justify-content-end">
            <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" (click)="addNewContest()">
              <mat-icon class="mr-2">play_circle_outlined</mat-icon>
              {{ 'generic.create-new-contest' | translate }}
            </button>
          </div>
        </div>
      }
      <ng-container>
        @if (contestDataSource && contestDataSource?.data.length > 0) {
          <mat-table [dataSource]="contestDataSource" matSort
            class="table-primary">
            <ng-container matColumnDef="title">
              <mat-header-cell *matHeaderCellDef> {{ 'generic.title' | translate }}</mat-header-cell>
              <div class="row flex-column">
                <mat-cell *matCellDef="let row"> {{ row.title }}</mat-cell>
              </div>
            </ng-container>
            <ng-container matColumnDef="created_at">
              <mat-header-cell *matHeaderCellDef> {{ 'generic.opening-date' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row.created_at | date:'shortDate' }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="closing_date">
              <mat-header-cell *matHeaderCellDef> {{ 'generic.closing-date' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row">
                @if (row.closing_date) {
                  <span>{{ row.closing_date | date:'shortDate' }}</span>
                }
                @if (!row.closing_date) {
                  <span>{{ 'generic.collecting' | translate }}</span>
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef class="text-center">{{ 'generic.actions' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <div class="row flex-column space-between">
                  <button class="my-2" mat-button (click)="showContest(row)" color="primary">
                    <small>{{ 'generic.buttons.go-to-contest' | translate }}</small>
                    <mat-icon>forward</mat-icon>
                  </button>
                  @if (!row.closing_date) {
                    <button class="my-2" mat-button (click)="copyLink(row.link)" color="primary">
                      <small>{{ 'generic.buttons.copy-link' | translate }}</small>
                    </button>
                  }
                  @if (!row.closing_date) {
                    <button class="my-2" mat-button (click)="closeContest(row)" color="warn">
                      <small>{{ 'generic.buttons.close-contest' | translate }}</small>
                    </button>
                  }
                </div>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="contestDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: contestDisplayedColumns;"></mat-row>
          </mat-table>
        }
        @if (decision_table?.contests?.length > 0) {
          <mat-paginator #contestsPaginator
          [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
        }
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #invitePages>
  <div class="row container pt-4 pb-2 mx-auto">
    <div class="col-12 p-0 m-0">

      <div>

        @if (invitationPagesDataSource && invitationPagesDataSource?.data.length == 0) {
          <div class="row">
            <div class="col-12 text-center mb-4 mt-2">
              <p>
                {{ 'components.decision-table.show-decision-table.no-invite-pages' | translate }}
              </p>
            </div>
            <div class="col-12 d-flex justify-content-center my-5">
              <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" (click)="addNewInvitationPage()">
                <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                {{ 'components.decision-table.show-decision-table.add-invite-page' | translate }}
              </button>
            </div>
          </div>
        }

        @if (invitationPagesDataSource && invitationPagesDataSource.data.length > 0) {
          <div class="row justify-content-center mb-4">
            @if (!decision_table?.decision_table_invitation_page_id) {
              <div class="col-12 d-flex justify-content-between"
                >
                <mat-card style="background-color: #caaf49; color: white;"
                  class="py-2 px-5 border-0 d-flex align-items-center">
                  {{ 'generic.alert.no_active_module' | translate }}
                </mat-card>
                <button class="btn-custom border-0 d-flex align-items-center px-5 py-2 mr-2"
                  (click)="openInvitationPagesSettings()">
                  <mat-icon class="mr-2">settings</mat-icon>
                  {{ 'generic.settings' | translate }}
                </button>
                <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" (click)="addNewInvitationPage()">
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                  {{ 'components.decision-table.show-decision-table.add-invite-page' | translate }}
                </button>
              </div>
            }
            @if (decision_table?.decision_table_invitation_page_id) {
              <div class="col-12 d-flex justify-content-end">
                <button class="btn-custom border-0 d-flex align-items-center px-5 py-2 mr-2"
                  (click)="openInvitationPagesSettings()">
                  <mat-icon class="mr-2">settings</mat-icon>
                  {{ 'generic.settings' | translate }}
                </button>
                <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" (click)="addNewInvitationPage()">
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                  {{ 'components.decision-table.show-decision-table.add-invite-page' | translate }}
                </button>
              </div>
            }
          </div>
        }

        <!-- Tabella delle pagine di invito -->
        @if (invitationPagesDataSource && invitationPagesDataSource?.data.length > 0) {
          <div class="row">
            @if (decision_table?.decision_table_invitation_page_id) {
              <div class="col-3">
                <app-qr-code [join_address]="invitationPageUrl" [organization_logo]="currentOrganization?.logo_link">
                </app-qr-code>
              </div>
            }
            <div [classList]="[decision_table?.decision_table_invitation_page_id ? 'col-9' : 'col-12']">
              <mat-table [dataSource]="invitationPagesDataSource" matSort class="table-primary">
                <!-- Definizione colonne -->
                <ng-container matColumnDef="title">
                  <mat-header-cell *matHeaderCellDef> {{ 'generic.title' | translate }}</mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{ row.title }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="created_at">
                  <mat-header-cell *matHeaderCellDef> {{ 'generic.creation-date' | translate }}</mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{ row.created_at | date:'shortDate' }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="status">
                  <mat-header-cell *matHeaderCellDef> {{ 'generic.status.status' | translate }}</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    @if (row.id === decision_table?.decision_table_invitation_page_id) {
                      <mat-chip class="p-2 rounded" selected color="primary"
                        >
                        {{ "generic.active" | translate }}
                      </mat-chip>
                    }
                    @if (row.id !== decision_table?.decision_table_invitation_page_id) {
                      <mat-chip class="p-2 rounded">
                        {{ 'generic.deactive' | translate }}
                      </mat-chip>
                    }
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef class="text-center">{{ 'generic.actions' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <div class="row flex-column space-between">
                      <button class="mb-2" mat-button (click)="addNewInvitationPage(row.id)" color="primary">
                        <small>{{ 'components.decision-table.show-decision-table.go-to-invitation-page' | translate
                        }}</small>
                        <mat-icon>forward</mat-icon>
                      </button>
                      @if (row.id === decision_table?.decision_table_invitation_page_id) {
                        <button class="my-2" mat-button
                          (click)="updateInvitationPageStatus(row.id, 'deactive')" color="warn">
                          <small>{{ 'generic.deactivate' | translate }}</small>
                        </button>
                      } @else {
                        <button class="my-2" mat-button (click)="updateInvitationPageStatus(row.id, 'active')"
                          color="primary">
                          <small>{{ 'generic.activate' | translate }}</small>
                        </button>
                      }
                    </div>
                  </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="invitationPagesDisplayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: invitationPagesDisplayedColumns;"></mat-row>
              </mat-table>
              @if (decision_table.invitation_pages?.length > 0) {
                <mat-paginator #invitationPagesPaginator
                [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
              }
            </div>
          </div>
        }
      </div>


      @if (decision_table?.join_requests?.length > 0) {
        <h3 class="mt-5 mb-2 font-weight-bold text-center">
          {{
          "generic.join-requests"
          | translate
          }}
        </h3>
      }

      @if (decision_table?.join_requests?.length > 0) {
        <mat-table [dataSource]="decision_table.join_requests" matSort class="table-primary mt-4">
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> {{ 'generic.name' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let request"> {{ request.name }} {{ request.surname }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef> {{ 'generic.email' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let request"> {{ request.email }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="number_phone">
            <mat-header-cell *matHeaderCellDef> {{ 'generic.phone' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let request">
              @if (request.number_phone) {
                <span>{{ request.number_phone }}</span>
              } @else {
                N/A
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef> {{ 'generic.status.status' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let request">
              <mat-chip class="p-2 rounded" selected
                [color]="request.status === 'approved' ? 'primary' : (request.status === 'refused' ? 'warn' : 'default')">
                {{ ('generic.' + request.status) | translate }}
              </mat-chip>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef class="text-center">{{ 'generic.actions' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let request">
              @if (request.status === 'pending') {
                <div class="row flex-column space-between">
                  <button class="my-2" mat-button (click)="updateJoinRequestStatus(request.id, 'approved')"
                    color="primary">
                    <small>{{ 'generic.approve' | translate }}</small>
                  </button>
                  <button class="my-2" mat-button (click)="updateJoinRequestStatus(request.id, 'refused')" color="warn">
                    <small>{{ 'generic.refuse' | translate }}</small>
                  </button>
                </div>
              } @else {
                N/A
              }
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="joinRequestsDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: joinRequestsDisplayedColumns;"></mat-row>
          @if (decision_table.join_requests?.length > 0) {
            <mat-paginator #joinRequestsPaginator
            [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
          }
        </mat-table>
      }
    </div>
  </div>
</ng-template>


<ng-template #currentEvaluationSessionTemplate>
  <div class="row container pt-2 pb-2 mx-auto">
    <div class="col-12 p-0 m-0">
      @if (getActiveEvaluationSession()) {
        <div class="row mb-4">
          <div class="col-12 d-flex justify-content-end">
            <button class="btn-custom border-0 d-flex align-items-center px-5 py-2 mr-3" (click)="extractTeamData()">
              <fa-icon class="mr-2" [icon]="faDownload"></fa-icon>
              <span>{{ "generic.export-team-data" | translate }}</span>
            </button>
            <button class="btn-custom border-0 d-flex align-items-center px-5 py-2"
              (click)="toggleAddNewTeamMemberMode()" [ngClass]="singleTeamMemberToAddActive ? 'bg-danger' : ''">
              @if (!singleTeamMemberToAddActive) {
                <fa-icon class="mr-2" [icon]="faPlusCircle"></fa-icon>
              }
              @if (singleTeamMemberToAddActive) {
                <fa-icon class="mr-2" [icon]="faTimes"></fa-icon>
              }
              @if (!singleTeamMemberToAddActive) {
                <span>{{
                'components.decision-table.new-decision-table.compile-proposal.add-team-member' | translate }}</span>
              }
              @if (singleTeamMemberToAddActive) {
                <span>{{ 'generic.cancel' | translate }}</span>
              }
            </button>
          </div>
          @if (singleTeamMemberToAddActive) {
            <div class="col-12">
              <div class="box px-0 box-two-row mb-0 mt-4 border-modify pb-2"
                [ngClass]="team_member_in_evaluation_session ? 'bg-red' : ''">
                <ng-container>
                  <div class="my-4">
                    <app-single-team-member [team_member]="singleTeamMemberToAdd" [removable]="false" />
                  </div>
                  <div class="row mx-auto flex-row-reverse">
                    <button matButton="filled" color="primary" (click)="addNewTeamMemberToCurrentSessionEvaluation()"
                      class="mr-2" [disabled]="(!singleTeamMemberIsValid || !singleTeamMemberToAddActive)">{{
                      'generic.buttons.add' | translate }}
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          }
          @if (team_member_in_evaluation_session) {
            <div class="col-12">
              <span class="d-flex alert-danger text-center px-5 py-2 mb-2 border-0">{{
                'components.decision-table.new-decision-table.compile-proposal.team-member-is-already-in-evaluation-session'
              | translate }}</span>
            </div>
          }
        </div>
      }

      @if (currentTeamMembersDataSource && currentTeamMembersDataSource?.data.length == 0) {
        <div class="row">
          <div class="col-12 text-center mb-4 mt-2">
            <p>
            {{ 'generic.no-proposals' | translate }}</p>
          </div>
        </div>
      }
      @if (currentTeamMembersDataSource) {
        <mat-table [dataSource]="currentTeamMembersDataSource" class="table-primary">
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> {{ 'generic.name' | translate }}</mat-header-cell>
            <div class="row flex-column">
              <mat-cell *matCellDef="let row"> {{ row.name }}</mat-cell>
            </div>
          </ng-container>
          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef> {{ 'generic.email' | translate }}</mat-header-cell>
            <div class="row flex-column">
              <mat-cell *matCellDef="let row"> {{ row.email }}</mat-cell>
            </div>
          </ng-container>
          <ng-container matColumnDef="role">
            <mat-header-cell *matHeaderCellDef> {{
              "generic.roles.process-role" | translate
              }}
            </mat-header-cell>
            <div class="row flex-column">
              <mat-cell *matCellDef="let row">
                {{
                processRolesService.getProcessRolesValueByKey(
                row?.process_role
                )
                }}
              </mat-cell>
            </div>
          </ng-container>
          <ng-container matColumnDef="response_status">
            <mat-header-cell *matHeaderCellDef> {{ 'components.decision-table.decision-table-dashboard.answers-to-form'
              | translate }}
            </mat-header-cell>
            <div class="row flex-column">
              <mat-cell *matCellDef="let row">
                <mat-chip-list>
                  @if (processRolesService.isConstulted(row.process_role)) {
                    @if (row.response_stamps && row.response_stamps.completed == true) {
                      <mat-chip selectable="false"
                        style="justify-content:center; background-color: #00bc1d;" class="text-white">{{
                        'generic.answers.yes' | translate }}
                      </mat-chip>
                    }
                    @if (row.response_stamps && row.response_stamps.completed == false) {
                      <mat-chip selectable="false"
                        style="justify-content:center; background-color: #bca900;" class="text-white">{{
                        'generic.answers.draft' | translate }}
                      </mat-chip>
                    }
                    @if (!row.response_stamps) {
                      <mat-chip selectable="false"
                        style="justify-content:center; background-color: #ff0000;" class="text-white">{{
                        'generic.answers.no' | translate }}
                      </mat-chip>
                    }
                  }
                  @if (!processRolesService.isConstulted(row.process_role)) {
                    <mat-chip selectable="false" style="justify-content:center; background-color: grey;"
                      class="text-white">N/A
                    </mat-chip>
                  }
                </mat-chip-list>
              </mat-cell>
            </div>
          </ng-container>
          <ng-container matColumnDef="email_status">
            <mat-header-cell *matHeaderCellDef> {{ 'components.decision-table.decision-table-dashboard.email-status' |
              translate }}
            </mat-header-cell>
            <div class="row flex-column">
              <mat-cell *matCellDef="let row">
                <mat-chip-list>
                  <mat-chip (click)="showEmailResponses(row)" role="button" selectable="true"
                    style="justify-content:center;" [matTooltip]="emailStatusByTeamMember(row)"
                    [matTooltipPosition]="'below'" [ngStyle]="{'background-color':emailColorByTeamMember(row)}"
                    class="text-white cursor">
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                  </mat-chip>
                  <button (click)="resendInvitation(row)" color="primary" mat-icon-button
                    matTooltip="{{'components.decision-table.decision-table-dashboard.tooltip.resend-email' | translate}}"
                    [matTooltipPosition]="'below'">
                    <fa-icon [icon]="faBullhorn"></fa-icon>
                  </button>
                </mat-chip-list>
              </mat-cell>
            </div>
          </ng-container>
          <mat-header-row *matHeaderRowDef="teamMemberDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: teamMemberDisplayedColumns;"></mat-row>
        </mat-table>
        <mat-paginator #currentTeamPaginator [pageSizeOptions]="[5, 10, 25, 100]"
        aria-label="Select page of users"></mat-paginator>
      }

      <!-- <div class="row justify-content-center my-5" *ngIf="lastEvaluationSession && lastEvaluationSession?.settings">
      <div
        class="container-fluid bg-white px-0 mx-n-24 w-100 border-bottom-grey container"
        >
        <div class="container py-4 px-4 px-md-0 mx-5">
          <div class="row my-3 px-4">
            <mat-label class="label-box ml-2 font-weight-bold">
              {{
              "components.decision-table.show-decision-table.round-settings"
              | translate
              }}
              <i class="icon-circle_info grey-color"></i>
            </mat-label>
          </div>
          <div class="row my-4">
            <div
              class="toggle-container col-5 d-inline-block"
              appearance="fill"
              >
              <i class="icon-circle_info abs-tr"></i>
              <mat-label>{{
                "components.decision-table.show-decision-table.ask-authorizations-to-modify-proposal"
                | translate
              }}</mat-label>
              <div>
                <span class="mr-2">{{
                  "generic.answers.no" | translate
                }}</span>
                <mat-slide-toggle
                  class="toggle"
                  disabled
                  [ngModel]="lastEvaluationSession?.settings?.review_enabled"
                  >{{ "generic.answers.yes" | translate }}</mat-slide-toggle
                  >
                </div>
                <i class="abs-tr icon-circle_info grey-color"></i>
              </div>
              <div
                class="toggle-container offset-1 col-5 d-inline-block"
                appearance="fill"
                >
                <i class="icon-circle_info abs-tr"></i>
                <mat-label
                  >{{
                  "components.decision-table.show-decision-table.ask-authorization-add-proposals"
                  | translate
                  }}
                </mat-label>
                <div>
                  <span class="mr-2">{{
                    "generic.answers.no" | translate
                  }}</span>
                  <mat-slide-toggle
                    class="toggle"
                    disabled
                    [ngModel]="lastEvaluationSession?.settings?.provide_new_proposal_enabled"
                    >{{ "generic.answers.yes" | translate }}</mat-slide-toggle
                    >
                  </div>
                  <i class="abs-tr icon-circle_info grey-color"></i>
                </div>
              </div>
              <div class="row my-4">
                <div class="toggle-container col-5 d-inline-block" appearance="fill">
                  <i class="icon-circle_info abs-tr"></i>
                  <mat-label>{{'components.decision-table.show-decision-table.ask-anonimity' | translate}}</mat-label>
                  <div>
                    <span class="mr-2">{{'generic.answers.no' | translate}}</span>
                    <mat-slide-toggle class="toggle"
                      disabled
                    [ngModel]="lastEvaluationSession?.settings.anonymous_survey_enabled">{{'generic.answers.yes' | translate}}</mat-slide-toggle>
                  </div>
                  <i class="abs-tr icon-circle_info grey-color"></i>
                </div>
                <div
                  class="toggle-container offset-1 col-5 d-inline-block"
                  appearance="fill"
                  >
                  <i class="icon-circle_info abs-tr"></i>
                  <mat-label
                    >{{
                    "components.decision-table.show-decision-table.ask-can-abstain"
                    | translate
                    }}
                  </mat-label>
                  <div>
                    <span class="mr-2">{{
                      "generic.answers.no" | translate
                    }}</span>
                    <mat-slide-toggle
                      class="toggle"
                      disabled
                      [ngModel]="lastEvaluationSession?.settings?.can_abstain"
                      >{{ "generic.answers.yes" | translate }}</mat-slide-toggle
                      >
                    </div>
                    <i class="abs-tr icon-circle_info grey-color"></i>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </ng-template>

    <ng-template #proposalsTemplate>
      <!-- colored box -->
      <div class="row container pt-4 pb-2 mx-auto">
        @for (proposal of proposals; track proposal) {
          <div class="col-12 box box-two-row border-0 rounded pb-0" [ngClass]="getClassSuggestion(proposal)"
            >
            <ng-container>
              <div class="row mt-0 mb-1">
                <i class="icon-show abs-tr p-2 main-color" (click)="editProposal(proposal)"></i>
                <!-- <i class="icon-edit abs-tr p-2 main-color" (click)="editProposal(proposal)"></i> -->
                <div class="col-1 icon-container">
                  <!-- <mat-checkbox [checked]="proposal.evaluation_session" [disabled]="pFroposal.evaluation_session"></mat-checkbox> -->
                  @if (!proposal.evaluation_session && decision_table.closing_date === null) {
                    <mat-checkbox
                    (change)="proposalCheckedOnChange(proposal)"></mat-checkbox>
                  }
                </div>
                <div class="col-4 col-lg-2 info-element">
                  <p class="title">
                    @if (isAlexion) {
                      {{ "generic.session" | translate }}
                    } @else {
                      {{ "generic.proposal" | translate }}
                    }
                  </p>
                  <p class="description">{{ proposal.title }}</p>
                </div>
                <div class="col-3 col-lg-2 info-element" *appHideIfOrganization="'alexion'">
                  <p class="title">{{ "components.decision-table.show-decision-table.proposed-by" | translate }}</p>
                  <div class="content-grid">
                    <img class="avatar-img" src="assets/img/user-placeholder.jpg" />
                    <div>
                      <p class="description">{{ proposal?.proposed_by?.name }}</p>
                      <p class="subline m-0 p-0">{{ proposal?.proposed_by?.email }}</p>
                      <p class="subline m-0 p-0">{{
                      getProcessRolesService().getProcessRolesValueByKey(proposal?.proposed_by?.process_role) }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-4 col-lg-2 info-element" *appHideIfOrganization="'alexion'">
                  <p class="title">
                    @if (!proposal.is_contest_proposal) {
                      <span>{{
                        "components.decision-table.show-decision-table.creation-session"
                        | translate
                      }}</span>
                    }
                    @if (proposal.is_contest_proposal) {
                      <span>{{
                        "components.decision-table.show-decision-table.creation-contest"
                        | translate
                      }}</span>
                    }
                  </p>
                  @if (!proposal.is_contest_proposal) {
                    <div>
                      @if (
                        proposal.creation_session > 0) {
                        <p class="description">
                          {{ "generic.session" | translate }} {{ proposal.creation_session }}
                        </p>
                      } @else {
                        <p class="description">
                          {{
                          "components.decision-table.show-decision-table.table-opening"
                          | translate
                          }}
                        </p>
                      }
                    </div>
                  }
                  @if (proposal.is_contest_proposal) {
                    <p class="description">
                      {{ getContestProposalById(proposal.creation_session)?.title }}
                    </p>
                  }
                </div>
                <div class="col-5 offset-1 col-lg-2 offset-lg-0 info-element">
                  <p class="title">
                    {{
                    (isAlexion ? 'pages.task-management.component.visit-date' :
                    "components.decision-table.show-decision-table.when-evaluated")
                    | translate
                    }}
                  </p>
                  @if (proposal.evaluation_session) {
                    <p class="description">
                      @if (!isAlexion) {
                        {{ "generic.session" | translate }}
                        {{ proposal.evaluation_session }}
                      } @else {
                        {{ proposal?.visit_date ? (proposal.visit_date | date) : "N/A" }}
                      }
                    </p>
                  } @else {
                    <p class="description">
                      {{
                      "components.decision-table.show-decision-table.not-evaluated-yet"
                      | translate
                      }}
                    </p>
                  }
                </div>
                <div class="col-5 col-lg-3 info-element">
                  <p class="title">
                    {{
                    "components.decision-table.show-decision-table.obtained-score"
                    | translate
                    }}
                  </p>
                  <div class="d-flex">
                    @if (!isAlexion || (isAlexion && proposal.risk_index !== 'NaN') || proposal?.result === 'INEVALUATION') {
                      <mat-progress-bar
                      [value]="isAlexion ? proposal.risk_index : (proposal.score / proposal.score_total) * 100"></mat-progress-bar>
                    }
                    @if (!isAlexion) {
                      @if (
                        proposal.evaluation_session && proposal?.score_total
                        ) {
                        <mat-label>{{ proposal.score }}/{{
                          proposal.score_total
                          }}
                        </mat-label>
                      }
                    } @else {
                      @if (proposal?.risk_index == 'NaN' && proposal?.result !== 'INEVALUATION') {
                        <mat-label
                        style="font-size: 16px">{{ 'generic.calculating' | translate }}</mat-label>
                      }
                      @if (proposal?.risk_index && proposal?.risk_index !== 'NaN') {
                        <mat-label>{{ proposal.risk_index }}%
                        </mat-label>
                      }
                    }
                  </div>
                </div>
              </div>
              <div class="footer" *appHideIfOrganization="'alexion'">
                @if (proposal.evaluation_session) {
                  <span>{{ getTextForSuggestion(proposal)
                  }}</span>
                } @else {
                  <span>{{
                    "components.decision-table.show-decision-table.not-evaluated-yet"
                    | translate
                  }}</span>
                }
                <i class="abs-br px-3 abs-center-y d-table" [ngClass]="getIconSuggestion(proposal)"></i>
              </div>
            </ng-container>
          </div>
        }
      </div>

      <!-- Scelta opzionale delle proposte two buttons -->
      <div *appHideIfOrganization="'alexion'">
        @if (decision_table.closing_date === null) {
          <div
            class="container-fluid bg-white px-0 mx-n-24 w-100 border-bottom-grey">
            <div class="container py-4 px-0">
              <div class="row justify-content-around mt-4 mb-5">
                @if (decision_table?.weights_is_setted && evaluationSessionActive) {
                  <button matButton="filled"
                    color="primary" (click)="editSessionWeights(false)">
                    {{
                    "components.decision-table.show-decision-table.view-weights"
                    | translate
                    }}
                  </button>
                }
                <button matButton="filled" color="primary" [disabled]="numOfProposalEvaluated == 0 || true"
                  (click)="generateProposal()">
                  {{
                  "components.decision-table.show-decision-table.create-proposal"
                  | translate
                  }}
                  <label class="label-bottom">{{
                    "components.decision-table.show-decision-table.info-create-proposal"
                    | translate
                  }}</label>
                </button>
                <button matButton="filled" color="primary" (click)="newProposal()"
                  [disabled]="locked || decision_table.closing_date">
                  {{
                  "components.decision-table.new-decision-table.compile-proposal.add-proposal"
                  | translate
                  }}
                </button>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Avviare una nuova sessione di valutazione yes or no -->
      @if (!locked && decision_table.closing_date === null) {
        <div class="container-fluid bg-white px-0 mx-n-24 w-100 border-top-grey border-bottom-grey"
          >
          <div class="container py-4 px-5">
            <div class="row py-4 two-radio-box mt-0 bg-transparent border-bottom-0">
              <div class="container px-0">
                <p class="title">
                  {{
                  "components.decision-table.show-decision-table.ask-start-new-session"
                  | translate
                  }}
                </p>
                <mat-radio-group class="col-12 mat-radio-box px-0" aria-label="Select an option" name="start_new_evaluation"
                  [(ngModel)]="startNewEvaluationChoice">
                  <mat-grid-list cols="12" rowHeight="100px">
                    <ng-container>
                      <mat-grid-tile colspan="6" (click)="onClickStartNewSession(true)">
                        <mat-radio-button [value]="true" class="col-12">{{
                          "generic.answers.yes" | translate
                          }}
                        </mat-radio-button>
                      </mat-grid-tile>
                      <mat-grid-tile colspan="6" (click)="onClickStartNewSession(false)">
                        <mat-radio-button [value]="false" class="col-12">{{
                          "generic.answers.no" | translate
                          }}
                        </mat-radio-button>
                      </mat-grid-tile>
                    </ng-container>
                  </mat-grid-list>
                </mat-radio-group>
              </div>
            </div>
            @if (startNewEvaluationChoice && startNewEvaluation == false) {
              <div class="row justify-content-center">
                <button matButton="filled" [disabled]="loading" color="primary" (click)="onClickConfirmStartNewSession()">
                  {{ "generic.buttons.confirm" | translate }}
                </button>
              </div>
            }
          </div>
        </div>
      }

      @if (startNewEvaluation && !locked) {
        <!-- two datepicker -->
        <div class="container-fluid bg-white px-0 mx-n-24 w-100 border-bottom-grey">
          <div class="container py-4 px-0">
            <div class="row px-4">
              <mat-form-field class="col-6 col-lg-4 datepicker-custom-button mt-1" (click)="dp_startEvaluationDate.open()">
                <mat-label>{{
                  "components.decision-table.show-decision-table.start-session-date"
                  | translate
                  }}
                </mat-label>
                <input matInput [matDatepicker]="dp_startEvaluationDate" name="start_evaluation_date"
                  class="color-default ng-trim-ignore" [(ngModel)]="modelStartNewEvaluation.evaluation_start"
                  [matDatepickerFilter]="startEvaluationFilter" (dateChange)="startEvaluationDateOnChange()" disabled />
                <mat-datepicker-toggle matSuffix [for]="dp_startEvaluationDate">
                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down
                  </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #dp_startEvaluationDate disabled="false"></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="col-6 col-lg-4 datepicker-custom-button mt-1" (click)="dp_endEvaluationDate.open()">
                <mat-label>{{
                  "components.decision-table.show-decision-table.end-session-date"
                  | translate
                  }}
                </mat-label>
                <input matInput [matDatepicker]="dp_endEvaluationDate" name="end_evaluation_date"
                  class="color-default ng-trim-ignore" [(ngModel)]="modelStartNewEvaluation.evaluation_end"
                  [matDatepickerFilter]="endEvaluationFilter" disabled />
                <mat-datepicker-toggle matSuffix [for]="dp_endEvaluationDate">
                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down
                  </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #dp_endEvaluationDate disabled="false"></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- settaggi round -->
        <div class="container-fluid bg-white px-0 mx-n-24 w-100 border-bottom-grey">
          <div class="container py-4 px-4 px-md-0">
            <div class="row my-3 px-4">
              <mat-label class="label-box ml-2 font-weight-bold">
                {{
                "components.decision-table.show-decision-table.round-settings"
                | translate
                }}
                <i class="icon-circle_info grey-color"></i>
              </mat-label>
            </div>
            <div class="row my-4">
              <div class="toggle-container col-5 d-inline-block" appearance="fill">
                <i class="icon-circle_info abs-tr"></i>
                <mat-label>{{
                  "components.decision-table.show-decision-table.ask-authorizations-to-modify-proposal"
                  | translate
                  }}
                </mat-label>
                <div>
                  <span class="mr-2">{{
                    "generic.answers.no" | translate
                  }}</span>
                  <mat-slide-toggle class="toggle" [ngModel]="modelStartNewEvaluation?.settings.review_enabled"
                    (ngModelChange)="modelStartNewEvaluation.settings.review_enabled = $event">{{ "generic.answers.yes" |
                    translate }}
                  </mat-slide-toggle>
                </div>
                <i class="abs-tr icon-circle_info grey-color"></i>
              </div>
              <div class="toggle-container offset-1 col-5 d-inline-block" appearance="fill">
                <i class="icon-circle_info abs-tr"></i>
                <mat-label>{{
                  "components.decision-table.show-decision-table.ask-authorization-add-proposals"
                  | translate
                  }}
                </mat-label>
                <div>
                  <span class="mr-2">{{
                    "generic.answers.no" | translate
                  }}</span>
                  <mat-slide-toggle class="toggle"
                    [ngModel]="modelStartNewEvaluation?.settings.provide_new_proposal_enabled"
                    (ngModelChange)="modelStartNewEvaluation.settings.provide_new_proposal_enabled = $event">{{
                    "generic.answers.yes" | translate }}
                  </mat-slide-toggle>
                </div>
                <i class="abs-tr icon-circle_info grey-color"></i>
              </div>
            </div>
            <div class="row my-4">
              <div class="toggle-container col-5 d-inline-block" appearance="fill">
                <i class="icon-circle_info abs-tr"></i>
                <mat-label>{{ 'components.decision-table.show-decision-table.ask-anonimity' | translate }}</mat-label>
                <div>
                  <span class="mr-2">{{ 'generic.answers.no' | translate }}</span>
                  <mat-slide-toggle class="toggle" [ngModel]="modelStartNewEvaluation?.settings.anonymous_survey_enabled"
                    (ngModelChange)="modelStartNewEvaluation.settings.anonymous_survey_enabled = $event">{{
                    'generic.answers.yes' | translate }}
                  </mat-slide-toggle>
                </div>
                <i class="abs-tr icon-circle_info grey-color"></i>
              </div>
              <div class="toggle-container offset-1 col-5 d-inline-block" appearance="fill">
                <i class="icon-circle_info abs-tr"></i>
                <mat-label>{{
                  "components.decision-table.show-decision-table.ask-can-abstain"
                  | translate
                  }}
                </mat-label>
                <div>
                  <span class="mr-2">{{
                    "generic.answers.no" | translate
                  }}</span>
                  <mat-slide-toggle class="toggle" [ngModel]="modelStartNewEvaluation?.settings.can_abstain"
                    (ngModelChange)="modelStartNewEvaluation.settings.can_abstain = $event">{{ "generic.answers.yes" |
                    translate }}
                  </mat-slide-toggle>
                </div>
                <i class="abs-tr icon-circle_info grey-color"></i>
              </div>
            </div>
            <div class="row my-4">
              <div class="toggle-container col-5 d-inline-block" appearance="fill">
                <i class="icon-circle_info abs-tr"></i>
                <mat-label>{{
                  "components.decision-table.show-decision-table.ask-authorizations-to-weights"
                  | translate
                  }}
                </mat-label>
                <div>
                  <span class="mr-2">{{
                    "generic.answers.no" | translate
                  }}</span>
                  <mat-slide-toggle [disabled]="!update_weights_is_allow" class="toggle"
                    [ngModel]="modelStartNewEvaluation?.settings.weights_provided_users"
                    (ngModelChange)="modelStartNewEvaluation.settings.weights_provided_users = $event">{{
                    "generic.answers.yes" | translate }}
                  </mat-slide-toggle>
                </div>
                <div class="red-subline">
                  {{
                  "components.decision-table.show-decision-table.ask-authorizations-to-weights-description"
                  | translate
                  }}
                  <br><br>
                  @if (!update_weights_is_allow) {
                    <span>
                      {{
                      "components.decision-table.show-decision-table.ask-authorizations-to-weights-is-disabled"
                      | translate
                      }}
                    </span>
                  }
                </div>
                <i class="abs-tr icon-circle_info grey-color"></i>
              </div>
              @if (templateEmail?.length > 0) {
                <div class="toggle-container col-5 d-inline-block"
                  [ngClass]="{'offset-1': update_weights_is_allow}" appearance="fill">
                  <mat-label>{{ 'components.decision-table.select-template' | translate }}</mat-label>
                  <mat-select name="email_template" [ngModel]="modelStartNewEvaluation?.settings.template_email_id"
                    (ngModelChange)="modelStartNewEvaluation.settings.template_email_id = $event" required>
                    <mat-option></mat-option>
                    @for (template of templateEmail; track template) {
                      <mat-option [value]="template.id">{{ template.name }}
                      </mat-option>
                    }
                  </mat-select>
                  <i class="abs-tr icon-circle_info grey-color"></i>
                </div>
              }
            </div>
            @if (update_weights_is_allow && !isConsensus) {
              <div class="row my-5 justify-content-center">
                <button matButton="filled" color="primary" (click)="editSessionWeights()"
                  [disabled]="locked || decision_table.closing_date">
                  {{
                  "components.decision-table.show-decision-table.edit-weights"
                  | translate
                  }}
                </button>
              </div>
            }
            @if (this.decision_table?.weights_is_setted && !isConsensus) {
              <div class="row my-5 justify-content-center">
                <button matButton="filled" color="primary" (click)="editSessionWeights(false)">
                  {{
                  "components.decision-table.show-decision-table.view-weights"
                  | translate
                  }}
                </button>
              </div>
            }
            <!-- <div class="row my-4">
            <div class="toggle-container col-5 d-inline-block" appearance="fill">
              <i class="icon-circle_info abs-tr"></i>
              <mat-label>{{'generic.confidence-degree' | translate}}</mat-label>
              <div>
                <span class="mr-2">{{'generic.answers.no' | translate}}</span>
                <mat-slide-toggle class="toggle"
                  [ngModel]="modelStartNewEvaluation?.settings.degree_of_confidence_enabled"
                (ngModelChange)="modelStartNewEvaluation.settings.degree_of_confidence_enabled = $event">{{'generic.answers.yes' | translate}}</mat-slide-toggle>
              </div>
              <div class="red-subline">
                {{'components.decision-table.show-decision-table.temp-info-confidence-degree' | translate}}
              </div>
              <i class="abs-tr icon-circle_info grey-color"></i>
            </div>
            <div class="toggle-container offset-1 col-5 d-inline-block" appearance="fill">
              <i class="icon-circle_info abs-tr"></i>
              <mat-label>{{'components.decision-table.show-decision-table.ask-authorization-feedback' | translate}}</mat-label>
              <div>
                <span class="mr-2">{{'generic.answers.no' | translate}}</span>
                <mat-slide-toggle class="toggle"
                  [ngModel]="modelStartNewEvaluation?.settings.provide_feedback_enabled"
                (ngModelChange)="modelStartNewEvaluation.settings.provide_feedback_enabled = $event">{{'generic.answers.yes' | translate}}</mat-slide-toggle>
              </div>
              <div class="red-subline">
                {{'components.decision-table.show-decision-table.temp-info-confidence-degree' | translate}}
              </div>
              <i class="abs-tr icon-circle_info grey-color"></i>
            </div>
          </div> -->
        </div>
      </div>
      <!-- modifica team -->
      <div class="container-fluid px-0 mx-n-24 w-100">
        <div class="container py-4 px-0">
          <div class="row my-3 px-4">
            <mat-label class="label-box ml-2 font-weight-bold">
              {{
              "components.decision-table.show-decision-table.change-team"
              | translate
              }}
              <i class="icon-circle_info grey-color"></i>
            </mat-label>
          </div>
          <div class="row px-4 px-md-0">
            <div class="col-12 px-0">
              <!-- Box User -->
              @for (
                team_member of modelStartNewEvaluation.team_members; track
                team_member; let i = $index) {
                <div class="box px-0 box-two-row">
                  <app-single-team-member [team_member]="team_member"
                    (removeTeamMemberEvent)="removeTeamMember(team_member)" />
                </div>
              }
            </div>
            <button class="col-12 big-button my-4" mat-raised-button (click)="addNewTeamMember()">
              <i class="icon-Add"></i>
              {{ 'components.decision-table.new-decision-table.compile-proposal.add-team-member' | translate }}
            </button>
            <button class="col-12 big-button mb-4 mt-3 ml-auto" mat-raised-button (click)="openChartsModal()">
              <i class="icon-Add"></i>
              {{ 'components.decision-table.new-decision-table.compile-proposal.import-team-members-from-chart' |
              translate }}
            </button>
          </div>
          <div class="row justify-content-center">
            <button matButton="filled" color="primary" [disabled]="loading" (click)="onClickSaveAndStartSession()">
              {{ "generic.buttons.save-and-start-session" | translate }}
            </button>
          </div>
        </div>
      </div>
    }
  </ng-template>

  <ng-template #insightsAggregator>
    <div class="row container pt-4 pb-2 mx-auto justify-content-center">
      <table mat-table [dataSource]="insightsData" class="mat-elevation-z8" style="width: 100%;">

        <!-- Section Column -->
        <ng-container matColumnDef="section">
          <th mat-header-cell *matHeaderCellDef> Section </th>
          <td mat-cell *matCellDef="let element"> {{element.section}} </td>
        </ng-container>

        <!-- AI-Synthesized Insight Column -->
        <ng-container matColumnDef="insight">
          <th mat-header-cell *matHeaderCellDef> AI-Synthesized Insight </th>
          <td mat-cell *matCellDef="let element"> {{element.text}} </td>
        </ng-container>

        <!-- Status Light Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status Light </th>
          <td mat-cell *matCellDef="let element">
          <span class="status-light mr-auto ml-auto" [ngClass]="{
          'bg-success': element.status === 'green',
          'bg-warning': element.status === 'yellow',
          'bg-danger': element.status === 'red'
        }"></span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="insightsDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: insightsDisplayedColumns;"></tr>

      </table>

      @if (!insightsAIAnalysisGenerated && !insightsAIAnalysisLoading) {
        <button class="size-small danger text-white my-5"
          matButton="filled" (click)="generateInsightsAIAnalysis()">{{ 'modal.modal-ai-analysis.title' | translate }}
        </button>
      }
      @if (insightsAIAnalysisLoading) {
        <div class="d-flex justify-content-center my-5">
          <mat-progress-spinner diameter="30" strokeWidth="4" mode="indeterminate"></mat-progress-spinner>
        </div>
      }
      @if (insightsAIAnalysisGenerated) {
        <mat-card class="analysis-card my-5">
          <mat-card-header>
            <mat-card-title>🧠 AI-Synthesized Cross-Functional Analysis – NeuroRelief™</mat-card-title>
            <mat-card-subtitle>Executive Summary</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p>
              The overall assessment of <strong>NeuroRelief™</strong> highlights a moderate risk profile with a balance
              of promise and complexity. While the clinical data supports continued development, several
              interfunctional dependencies and strategic uncertainties must be addressed prior to advancing
              toward Phase 3 or commercialization partnerships.
            </p>
            <h3>🔍 Key Findings &amp; Interdependencies</h3>
            <ul>
              <li>
                <strong>Clinical–Regulatory Link</strong><br>
                Although the Phase 2b data demonstrates signal of efficacy, concerns around dosing clarity
                and endpoint validation may trigger regulatory resistance. The EMA is likely to request a
                new endpoint strategy or confirmatory study before submission, prolonging the timeline.
              </li>
              <li>
                <strong>Manufacturing–Market Access Risk Coupling</strong><br>
                The complex synthesis process, combined with questionable replicability, introduces
                scalability risk. This may lead to increased COGs, which—given the small patient population—could
                constrain margin expectations and weaken pricing negotiation leverage.
              </li>
              <li>
                <strong>Industrial–Funding &amp; Timing Gap</strong><br>
                The industrial section identifies moderate CapEx needs, yet no secured investment pathway is
                defined. A delay in funding or infrastructure readiness may misalign with the go-to-market
                window, especially if accelerated regulatory tracks are sought.
              </li>
              <li>
                <strong>Competitive Landscape Observations</strong><br>
                Two competitors are advancing in Phase 2, yet NeuroRelief™ exhibits a more clearly defined
                target population, presenting a potential strategic edge if differentiation is articulated
                effectively in HTA dossiers and branding.
              </li>
            </ul>
            <h3>📈 Strategic Implications</h3>
            <p>
              A targeted mitigation plan should be developed around CMC scalability and endpoint refinement,
              ideally supported by early advice from EMA or national agencies.
            </p>
            <p>
              A cross-functional fast-track alignment across RA, MA, and Industrial teams is essential to
              shorten the critical path to decision.
            </p>
            <p>
              Given the manageable IP/legal risk and promising differentiation signals, the asset retains
              high potential if key bottlenecks are addressed in parallel.
            </p>
            <h3>✅ Recommended Next Step for Review Board</h3>
            <p>
              Initiate a structured mitigation scenario workshop simulating:
            </p>
            <ol>
              <li>ROI impact with delayed launch vs resolved CMC</li>
              <li>Fast-track vs standard EMA submission timelines</li>
              <li>Break-even shifts based on margin stress testing</li>
            </ol>
          </mat-card-content>
        </mat-card>
      }

    </div>
  </ng-template>